import { render } from "./BackToTop.vue?vue&type=template&id=3e637c4a&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"

import "./BackToTop.vue?vue&type=style&index=0&id=3e637c4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e637c4a"]])

export default __exports__